export function transformSalesPersonCodeUIToModel(value: string): number {
  return parseFloat(value);
}

export function transformSalesPersonCodeModelToUI(value: number): string {
  return value.toString();
}
